module.exports = __webpack_public_path__ + "media/images/lp/sv/img/pc/header-bg-2103de83e26793f0fe2ba7d66f1e5ee3.png";